import React, { useState } from "react";
import PracticeGenericModal from "./PracticeGenericModal";
import { Eye } from "lucide-react";
import { Pagination } from "antd";

function GenericCard({
  genericQuestions,
  setGenericQuestions,
  pageSize,
  currentPage,
  onPageChange,
  setLoading,
  userDetail,
  guideId,
  setModuleInfo,
  moduleInfo,
}) {
  const [openGenericModal, setOpenGenericModal] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  function timeAgo(dateString) {
    if (!dateString) return "N/A";
    const now = new Date();
    const past = new Date(dateString);
    const diff = Math.floor((now - past) / 1000); // in seconds
    if (diff < 60) return `${diff} sec ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
    if (diff < 86400)
      return `${Math.floor(diff / 3600)} hour${
        Math.floor(diff / 3600) > 1 ? "s" : ""
      } ago`;
    if (diff < 604800)
      return `${Math.floor(diff / 86400)} day${
        Math.floor(diff / 86400) > 1 ? "s" : ""
      } ago`;
    if (diff < 2592000)
      return `${Math.floor(diff / 604800)} week${
        Math.floor(diff / 604800) > 1 ? "s" : ""
      } ago`;
    if (diff < 31536000)
      return `${Math.floor(diff / 2592000)} month${
        Math.floor(diff / 2592000) > 1 ? "s" : ""
      } ago`;

    // ✅ Years
    return `${Math.floor(diff / 31536000)} year${
      Math.floor(diff / 31536000) > 1 ? "s" : ""
    } ago`;
  }
  function formatNumber(num) {
    if (num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    }
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (num >= 1_000) {
      return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "k";
    }
    return num.toString();
  }

  const getDifficultyColor = (difficulty) => {
    switch (difficulty.toLowerCase()) {
      case "easy":
        return "text-green-600";
      case "medium":
        return "text-yellow-600";
      case "hard":
        return "text-red-600";
      default:
        return "text-gray-600";
    }
  };

  return (
    <>
      {openGenericModal && (
        <PracticeGenericModal
          setModuleInfo={setModuleInfo}
          moduleInfo={moduleInfo}
          openGenericModal={openGenericModal}
          setOpenGenericModal={setOpenGenericModal}
          setGenericQuestions={setGenericQuestions}
          genericQuestions={genericQuestions}
          selectedQuestion={selectedQuestion}
          setSelectedQuestion={setSelectedQuestion}
          userDetail={userDetail}
          setLoading={setLoading}
          guideId={guideId}
        />
      )}
      {genericQuestions ? (
        <>
          {genericQuestions?.openPoolPracticeQuestionsList?.map(
            (item, index) => {
              return (
                <>
                  <div className="border-2 rounded-lg p-6 hover-effect mt-4">
                    <div className="flex justify-between">
                      <span className=" text-sm text-gray-400">
                        {item.category}
                      </span>

                      <span className="text-sm text-gray-400">
                        {timeAgo(item.creationDate)}
                      </span>
                    </div>
                    <div className="text-lg font-semibold text-start mt-1">
                      {item.questionTitle}
                    </div>
                    <div className="flex gap-x-3 gap-y-2 items-center mt-3 flex-wrap">
                      {item.tags.map((tag, i) => {
                        return (
                          <span className="border-2 border-[#FEDF89] bg-[#FFFAEB] text-[#B54708] rounded-full px-3 py-[.1rem] text-sm">
                            {tag}
                          </span>
                        );
                      })}
                    </div>
                    {/* <div className="text-gray-500 mt-2 font-medium text-sm flex items-center gap-x-3">
                      <span>{item.industryType}</span>
                      <span className="border-l border-gray-500 h-4 mx-2"></span>
                      <span>Difficulty: {item.difficulty}</span>
                    </div> */}

                    <div className=" mt-3 flex justify-between flex-wrap gap-y-2">
                      <span className="flex gap-x-5 gap-y-2 items-center flex-wrap">
                        <span className="flex items-center gap-2 text-sm font-medium text-gray-500">
                          <Eye color="#6b7280" size={16} />{" "}
                          <span>
                            {formatNumber(item.viewCount)}{" "}
                            <span className="">views </span>{" "}
                          </span>
                        </span>
                        <span className="text-gray-500 font-medium text-sm flex gap-x-2 items-center">
                          <svg
                            width="15"
                            height="13"
                            viewBox="0 0 20 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.3327 16.5V14.8333C18.3327 13.2801 17.2704 11.9751 15.8327 11.605M12.916 1.7423C14.1376 2.23679 14.9993 3.43443 14.9993 4.83333C14.9993 6.23224 14.1376 7.42988 12.916 7.92437M14.166 16.5C14.166 14.9469 14.166 14.1703 13.9123 13.5577C13.574 12.741 12.9251 12.092 12.1083 11.7537C11.4957 11.5 10.7192 11.5 9.16602 11.5H6.66602C5.11288 11.5 4.33631 11.5 3.72374 11.7537C2.90698 12.092 2.25806 12.741 1.91975 13.5577C1.66602 14.1703 1.66602 14.9469 1.66602 16.5M11.2493 4.83333C11.2493 6.67428 9.75696 8.16667 7.91602 8.16667C6.07507 8.16667 4.58268 6.67428 4.58268 4.83333C4.58268 2.99238 6.07507 1.5 7.91602 1.5C9.75696 1.5 11.2493 2.99238 11.2493 4.83333Z"
                              stroke="#6b7280"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          {formatNumber(item.practiceCount)} Users Practiced
                        </span>
                        <span className="text-gray-500 font-medium text-sm flex gap-x-2 items-center">
                          <svg
                            width="13"
                            height="12"
                            viewBox="0 0 18 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.40156 1.8778C8.59363 1.48869 8.68966 1.29413 8.82004 1.23197C8.93347 1.17789 9.06525 1.17789 9.17869 1.23197C9.30906 1.29413 9.4051 1.48869 9.59717 1.8778L11.4194 5.56944C11.4761 5.68432 11.5045 5.74176 11.5459 5.78635C11.5826 5.82584 11.6266 5.85783 11.6754 5.88056C11.7306 5.90623 11.794 5.91549 11.9208 5.93402L15.9968 6.5298C16.4261 6.59253 16.6407 6.6239 16.74 6.72874C16.8264 6.81995 16.8671 6.94529 16.8506 7.06985C16.8317 7.21302 16.6763 7.36436 16.3656 7.66702L13.4172 10.5387C13.3253 10.6282 13.2794 10.673 13.2497 10.7263C13.2235 10.7734 13.2066 10.8252 13.2001 10.8788C13.1928 10.9393 13.2036 11.0025 13.2253 11.129L13.921 15.1851C13.9944 15.6129 14.031 15.8269 13.9621 15.9538C13.9021 16.0642 13.7955 16.1417 13.6719 16.1646C13.5299 16.1909 13.3378 16.0899 12.9536 15.8879L9.30966 13.9716C9.19613 13.9119 9.13936 13.882 9.07955 13.8703C9.0266 13.8599 8.97213 13.8599 8.91918 13.8703C8.85937 13.882 8.8026 13.9119 8.68906 13.9716L5.04512 15.8879C4.66095 16.0899 4.46886 16.1909 4.32683 16.1646C4.20325 16.1417 4.09662 16.0642 4.03663 15.9538C3.96768 15.8269 4.00437 15.6129 4.07774 15.1851L4.77342 11.129C4.79511 11.0025 4.80595 10.9393 4.79862 10.8788C4.79212 10.8252 4.77528 10.7734 4.74902 10.7263C4.71937 10.673 4.67341 10.6282 4.5815 10.5387L1.63315 7.66702C1.3224 7.36436 1.16703 7.21302 1.14812 7.06985C1.13167 6.94529 1.17231 6.81995 1.25872 6.72874C1.35804 6.6239 1.57266 6.59253 2.00189 6.5298L6.07794 5.93402C6.2047 5.91549 6.26808 5.90623 6.32328 5.88056C6.37215 5.85783 6.41615 5.82584 6.45284 5.78635C6.49427 5.74176 6.52262 5.68432 6.57933 5.56944L8.40156 1.8778Z"
                              stroke="#98A2B3"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span>Difficulty level:</span>
                          <span
                            className={`${getDifficultyColor(item.difficulty)}`}
                          >
                            {item?.difficulty?.charAt(0).toUpperCase() +
                              item?.difficulty?.slice(1)}
                          </span>
                        </span>
                      </span>
                      <span className="flex justify-end">
                        <button
                          className="btn-orange px-4 py-[.35rem] text-sm font-semibold"
                          onClick={() => {
                            setSelectedQuestion(item);
                            setOpenGenericModal(true);
                          }}
                        >
                          Practice Now
                        </button>
                      </span>
                    </div>
                  </div>
                </>
              );
            }
          )}
          <div className="flex justify-end mt-4">
            <Pagination
              current={currentPage}
              total={genericQuestions?.totalCount}
              pageSize={pageSize}
              onChange={onPageChange}
              showSizeChanger={true} // ✅ enable page size selector
              pageSizeOptions={["5", "10", "15", "20"]} // options for items per page
            />
          </div>
        </>
      ) : (
        <div className="mt-6 text-[#475467] font-medium">No results found.</div>
      )}
    </>
  );
}

export default GenericCard;
